"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decisionIdRegex = exports.LastLawLexKey = void 0;
var LastLawLexKey;
(function (LastLawLexKey) {
    LastLawLexKey["ANALYSIS"] = "JuriBaseAnalysis";
    LastLawLexKey["ARTICLES"] = "Articles";
    LastLawLexKey["GLOSSARY"] = "Glossary";
    LastLawLexKey["JURI_BASE_JURISPRUDENCE"] = "JuriBaseJurisprudence";
    LastLawLexKey["JURI_BASE_LEGIS"] = "JuriBaseLegis";
    LastLawLexKey["STATISTICS"] = "Statistics";
})(LastLawLexKey || (exports.LastLawLexKey = LastLawLexKey = {}));
exports.decisionIdRegex = /lawlex\d{12}jbj/i;
//# sourceMappingURL=LawLex.js.map